export default {
  category: Object.freeze({
    OWN_SERVICES: 'own-services', DENTAL_LAB_SERVICES: 'dental-lab-services', MEDICAL_ANALYSES: 'medical-analyses',
    NOT_DENTAL_LAB_SERVICES: 'not-dental-lab-services', ARCHIVE_SERVICES: 'archive-services',
    OWN_SERVICES_LABEL: 'Наши услуги', DENTAL_LAB_SERVICES_LABEL: 'Зуботехническая лаборатория',
    MEDICAL_ANALYSES_LABEL: 'Медицинские анализы', ARCHIVE_SERVICES_LABEL: 'Архивные услуги'
  }),
  settings: Object.freeze({POSITION_LOCAL_STORAGE_KEY: 'services-position'}),
}
